<template>
<div class="chapter">
<div class="inner_page">
<div id="fm4">
<a id="pageiii">
<p class="title"><span>JOHN GUARE</span></p>
<p class="title1"><span>A Free Man of Color</span></p>
<p class="image1">
<img alt="" class="figure" id="F1" src="images/9780802195005_0001.jpg"/>
</p>
<p class="title2"><span>Grove Press</span></p>
<p class="title2"><em class="italic">New York</em></p>
</a></div><a id="pageiii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802195005_title.vue?272599dc